import { createContext, useContext, useEffect, useState } from "react";
import { getCurrentUser } from "../services/user.service";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("user")) || null
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  async function hydrateUser() {
    const token = localStorage.getItem("token");

    if (!token) {
      setLoading(false);
      return;
    }

    try {
      const fullUser = await getCurrentUser();

      if (fullUser.id_role !== "R01") {
        logoutUser();
        return;
      }

      setUser(fullUser);
      localStorage.setItem("user", JSON.stringify(fullUser));

    } catch (e) {
      logoutUser();
    } finally {
      setLoading(false);
    }
  }

  hydrateUser();
}, []);

  function loginUser(userData) {
    setUser(userData); 
    localStorage.setItem("user", JSON.stringify(userData));
  }

  function logoutUser() {
  setUser(null);
  localStorage.removeItem("user");
  localStorage.removeItem("token");
}

  return (
    <AuthContext.Provider value={{ user, loading, loginUser, logoutUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
